export const CertManageRoutes = [
  {
    path: '/Admin/CertManage/Instructor',
    name: '考官证书管理',
    component: () => import('./Instructor/index.vue'),
    meta: {
      title: '考官证书管理'
    }
  }, {
    path: '/Admin/CertManage/Instructor/Edit',
    name: '考官证书管理编辑',
    component: () => import('./Instructor/Edit.vue'),
    meta: {
      title: '考官证书管理编辑'
    }
  }, {
    path: '/Admin/CertManage/Teacher',
    name: '教师证书管理',
    component: () => import('./Teacher/index.vue'),
    meta: {
      title: '教师证书管理'
    }
  }, {
    path: '/Admin/CertManage/Teacher/Edit',
    name: '教师证书管理编辑',
    component: () => import('./Teacher/Edit.vue'),
    meta: {
      title: '教师证书管理编辑'
    }
  }, {
    path: '/Admin/CertManage/Student',
    name: '测评证书管理',
    component: () => import('./Student/index.vue'),
    meta: {
      title: '测评证书管理'
    }
  }, {
    path: '/Admin/CertManage/Student/Edit',
    name: '测评证书管理编辑',
    component: () => import('./Student/Edit.vue'),
    meta: {
      title: '测评证书管理编辑'
    }
  },{
    path: '/Admin/CertManage/Certificate',
    name: '证书查看',
    component: () => import('./Certificate/index.vue'),
    meta: {
      title: '证书查看'
    }
  },
]



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminHome/CertManage/routes.js